import React from "react"
import PropTypes from "prop-types"

const DownArrowIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 12 12">
    <polygon
      transform="translate(6.000000, 5.500000) scale(1, -1) rotate(-180.000000) translate(-6.000000, -5.500000) "
      points="10.6 2 6 6.35135135 1.4 2 0 3.32432432 6 9 12 3.32432432" />
  </svg>
)

DownArrowIcon.propTypes = {
  style: PropTypes.object
}

export default DownArrowIcon



// WEBPACK FOOTER //
// ./src/components/icons/down-arrow-icon.jsx